import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    academic_period: '',
    group: '',
  },
}

export const timetablesUI = createSlice({
  name: 'timetablesUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setAcademicPeriod: (state, { payload }) => {
      state.tableFilters.academic_period = payload
    },
    setGroup: (state, { payload }) => {
      state.tableFilters.group = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setAcademicPeriod,
  setGroup,
  trackActiveFilters,
  clearAllFilters,
} = timetablesUI.actions

export default timetablesUI.reducer
